/**
 * Labstep
 *
 * @module components/Entity/ListCreate
 * @desc Entity List relying on Create container to create entities
 */

import { useHasAccessCreate } from 'labstep-web/components/Entity/Can/hooks';
import { EntityListCreateItem } from 'labstep-web/components/Entity/ListCreate/Item';
import { EntityListCreateSearchContainer as EntityListCreateSearch } from 'labstep-web/components/Entity/ListCreate/Search';
import { ToggleContainer } from 'labstep-web/containers/Toggle';
import type React from 'react';
import type { EntityListCreateProps } from './types';

export const EntityListCreate: React.FC<EntityListCreateProps> = ({
  entity,
  entityName,
  searchEntityName,
  searchParams,
  entities,
  onChangeCreateProps,
  list,
  disableAddButton = false,
}) => {
  const createPermission = useHasAccessCreate(entityName);
  return (
    <div className="toggle">
      <ToggleContainer>
        {({ toggle, toggled }) => (
          <EntityListCreateItem
            entities={entities}
            entityName={entityName}
            toggle={toggle}
            toggled={toggled}
            createPermission={createPermission}
            list={list}
            select={() => (
              <EntityListCreateSearch
                entity={entity}
                createEntityName={entityName}
                searchEntityName={searchEntityName}
                extraParams={searchParams}
                toggle={toggle}
                onChangeCreateProps={onChangeCreateProps}
              />
            )}
            disableAddButton={disableAddButton}
          />
        )}
      </ToggleContainer>
    </div>
  );
};
